import { useMemo } from 'react';
import useGenreUrlParams from './useGenreUrlParams';
import useGenre from './useGenre';
import useShowsByGenreId from '@/react-query/shows/hooks/useShowsByGenreId';
import { isShowNewlyReleased } from '@/helpers/common';

const useGenreShows = (queryParams) => {
  const { genreSlug, isViewingNewShows } = useGenreUrlParams();
  const { genre } = useGenre();
  const { id: genreId } = genre;

  const results = useShowsByGenreId({
    ...queryParams,
    enabled: !!(genreSlug && genreId),
    id: genreId
  });

  const { shows } = results;

  const newShows = useMemo(() => (shows || []).filter((g) => isShowNewlyReleased({ releaseDate: g.release_date })), [shows]);

  return {
    ...results,
    shows: isViewingNewShows ? newShows : shows
  };
};

export default useGenreShows;